//adding ordinal formatting to the due dates
const ordinalDateFormatter = (availableDueDate: number, locale = 'en') => {
    if (locale !== 'en') {
        return availableDueDate;
    }
    const j = availableDueDate % 10,
        k = availableDueDate % 100;
    if (j == 1 && k != 11) {
        return availableDueDate + 'st';
    }
    if (j == 2 && k != 12) {
        return availableDueDate + 'nd';
    }
    if (j == 3 && k != 13) {
        return availableDueDate + 'rd';
    }
    return availableDueDate + 'th';
};

export default ordinalDateFormatter;
